import { graphql, commitMutation } from 'react-relay';

const commit = (environment, args) => {
    const AccountSettings = require('../SocialNetworks/AccountSettings').default; // eslint-disable-line

    const mutation = graphql`
        mutation ModifyPinterestBoardMutation_esMutation($input: ModifyPinterestBoardInput!) {
            modifyPinterestBoard(input: $input) {
                user {
                    ...AccountSettings_user
                }
            }
        }
    `;

    const { userId, boardId, boardName, onSuccess = () => {}, onFailure = () => {} } = args;

    const input = { userId, boardId, boardName };

    commitMutation(environment, {
        mutation,
        variables: { input },
        onCompleted: (payload, errors) => {
            if (errors) {
                onFailure(errors);
                return;
            }
            onSuccess(payload);
        },
        onError: error => {
            onFailure([error]);
        },
    });
};

export default { commit };



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/ModifyPinterestBoardMutation.es.js